<!-- <p>visitor-invite-form works!</p> -->
<div class="visitor-invite-form-wrapper">
  <mat-card class="visitor-form-card">
    <mat-card-content class="visitor-form-card-content">
      <form [formGroup]="createNewVisitorForm" class="visitor-form-container">
        <mat-grid-list
          [cols]="screenInfo == ScreenType.Mobile ? '1' : '4'"
          rowHeight="80px"
          gutterSize="5px"
        >
          <mat-grid-tile
            *ngIf="
              (!isUniqueVisitor && isValid) ||
              (!isUniqueVisitor && !isValid && !isManuallyCheck) ||
              (!isUniqueVisitor && !isValid && isManuallyCheck)
            "
            [colspan]="screenInfo == ScreenType.Mobile ? '1' : '4'"
          >
            <div class="form-field-updates">
              <div
                *ngIf="!isUniqueVisitor && isValid"
                class="warn-banner"
                [ngStyle]="
                  screenInfo != ScreenType.Mobile
                    ? { 'font-size': '14px' }
                    : screenInfo == ScreenType.Mobile
                    ? { 'font-size': '12px' }
                    : {}
                "
              >
                <div class="warn-banner-text">
                  {{ phoneForm.get("phone").value }} already exists, Please
                  re-schedule!
                </div>
                <button (click)="onEditDetails()" mat-raised-button>
                  Edit Record
                </button>
                <div
                  *ngIf="!isUniqueVisitor && isValid"
                  class="searched-image-container"
                >
                  <img [src]="searchedImage" alt="Searched Image" />
                </div>
              </div>

              <div
                *ngIf="!isUniqueVisitor && !isValid && !isManuallyCheck"
                class="error-banner"
                [ngStyle]="
                  screenInfo != ScreenType.Mobile
                    ? { 'font-size': '16px' }
                    : screenInfo == ScreenType.Mobile
                    ? { 'font-size': '14px' }
                    : {}
                "
              >
                <div class="prompt-message">
                  {{ phoneForm.get("phone").value }} not yet checked-out!
                </div>
                <button (click)="onManualCheckVisitor()" mat-raised-button>
                  Check-Out
                </button>
              </div>
              <div
                *ngIf="!isUniqueVisitor && !isValid && isManuallyCheck"
                class="warn-banner"
                [ngStyle]="
                  screenInfo != ScreenType.Mobile
                    ? { 'font-size': '16px' }
                    : screenInfo == ScreenType.Mobile
                    ? { 'font-size': '14px' }
                    : {}
                "
              >
                <div class="prompt-message">
                  {{ phoneForm.get("phone").value }} been manually checked-out!
                </div>
                <button (click)="onEditDetails()" mat-raised-button>
                  Edit Record
                </button>
              </div>
            </div>
          </mat-grid-tile>
          <form class="phone-form-field" #f="ngForm" [formGroup]="phoneForm">
            <mat-grid-tile>
              <mat-form-field
                class="invite-form-fields custom-padding-fix"
                appearance="outline"
                subscriptSizing="dynamic"
              >
                <ngx-mat-intl-tel-input
                  #phoneInput
                  [enablePlaceholder]="true"
                  [required]="true"
                  [preferredCountries]="['in']"
                  [enableSearch]="true"
                  name="phone"
                  formControlName="phone"
                  [inputPlaceholder]="'Phone Number*'"
                  [label]="'Phone Number'"
                  (keypress)="inputValidator($event)"
                  [maxlength]="15"
                  (change)="onChangeNumber($event)"
                ></ngx-mat-intl-tel-input>
              </mat-form-field>
            </mat-grid-tile>
          </form>
          <mat-grid-tile>
            <mat-form-field
              subscriptSizing="dynamic"
              appearance="outline"
              class="invite-form-fields"
            >
              <mat-label>First Name</mat-label>
              <input formControlName="firstName" matInput />
            </mat-form-field>
            <!-- <mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
              class="invite-form-fields"
            >
              <mat-label>First Name*</mat-label>
              <input
                matInput
                [matAutocomplete]="auto"
                [formControl]="visitorCtrl"
                (input)="updateFormControlValue($event)"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="visitorSelect($event)"
              >
                <mat-option
                  *ngFor="let visitor of filteredVisitor | async"
                  [value]="visitor.visitorID"
                >
                  <img
                    alt=""
                    class="visitor-img"
                    [src]="visitor.profilePicture"
                    height="30"
                    width="36"
                  />
                  <span>{{ visitor.firstName + " " + visitor.lastName }}</span>
                  |
                  <small>{{ getCustomPhoneNumber(visitor.phoneNumber) }}</small>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field
              subscriptSizing="dynamic"
              appearance="outline"
              class="invite-form-fields"
            >
              <mat-label>Last Name</mat-label>
              <input
                formControlName="lastName"
                matInput
                placeholder=""
                value=""
              />
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field
              subscriptSizing="dynamic"
              appearance="outline"
              class="invite-form-fields"
            >
              <mat-label>Email</mat-label>
              <input formControlName="email" matInput placeholder="" value="" />
            </mat-form-field>
          </mat-grid-tile>
          <!-- <mat-grid-tile *ngIf="false">
            <mat-form-field
              class="invite-form-fields custom-padding-fix"
              appearance="outline"
              subscriptSizing="dynamic"
            >
              <ngx-mat-intl-tel-input
                #phoneInput
                [enablePlaceholder]="true"
                [required]="true"
                [preferredCountries]="['in']"
                [enableSearch]="true"
                name="phone"
                formControlName="phoneNumber"
                [inputPlaceholder]="'Phone Number *'"
                [label]="'Phone Number'"
                [maxlength]="15"
              ></ngx-mat-intl-tel-input>
              <mat-error
                *ngIf="createNewVisitorForm.controls['phoneNumber']?.errors?.['validatePhoneNumber']
                &&
                false"
                ><i>Enter valid number</i>
              </mat-error>
            </mat-form-field>
          </mat-grid-tile> -->
          <mat-grid-tile
            ><mat-form-field
              subscriptSizing="dynamic"
              appearance="outline"
              class="invite-form-fields"
            >
              <mat-label>Address</mat-label>

              <textarea
                class="address-text-area-field"
                formControlName="visitorAddress"
                cdkTextareaAutosize
                cdkAutosizeMaxRows="1"
                matInput
              ></textarea></mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field
              subscriptSizing="dynamic"
              appearance="outline"
              class="invite-form-fields"
            >
              <mat-label>Car Registration</mat-label>
              <input
                formControlName="carRegistration"
                matInput
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field
              subscriptSizing="dynamic"
              appearance="outline"
              class="invite-form-fields"
            >
              <mat-label>Visitor Category</mat-label>
              <mat-select formControlName="visitorCategory">
                <mat-option value="New Visitor"> New Visitor </mat-option>
                <mat-option value="Vip"> VIP </mat-option>
                <mat-option value="Guest"> Guest </mat-option>
                <mat-option value="Delivery"> Delivery </mat-option>
                <mat-option value="Domestic"> Domestic </mat-option>
                <mat-option value="Contractor"> Contractor </mat-option>
                <mat-option value="Labour"> Labour </mat-option>
                <mat-option value="Driver"> Driver </mat-option>
                <mat-option value="Driver"> Donor </mat-option>
                <mat-option value="Driver"> Recipient </mat-option>
              </mat-select>
            </mat-form-field></mat-grid-tile
          >
          <mat-grid-tile>
            <mat-form-field
              *ngIf="isDisabled"
              subscriptSizing="dynamic"
              appearance="outline"
              class="invite-form-fields"
            >
              <mat-label>Select Hosts*</mat-label>
              <input [disabled]="isDisabled" matInput />
            </mat-form-field>
            <mat-form-field
              *ngIf="!isDisabled"
              appearance="outline"
              class="question-subject-form-field"
              subscriptSizing="dynamic"
            >
              <mat-label>Select Hosts*</mat-label>
              <input
                matInput
                [formControl]="selectedUsersControl"
                [matAutocomplete]="autoAdmin"
              />
              <mat-icon
                style="background-color: transparent; color: #e93578"
                matSuffix
                (click)="clearInputField()"
                >clear</mat-icon
              >
              <mat-autocomplete
                (optionSelected)="addUser($event)"
                #autoAdmin="matAutocomplete"
              >
                <mat-option
                  *ngFor="let host of filteredHosts"
                  [value]="host.firstname + ' ' + host.lastname"
                >
                  <img
                    style="margin-right: 5px"
                    [src]="host.profilePicture"
                    height="30"
                    width="36"
                  />
                  <span> {{ host.firstname + " " + host.lastname }}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile
            [colspan]="
              screenInfo == ScreenType.Mobile ||
              createNewVisitorForm.controls.isReVisit.value
                ? '1'
                : '2'
            "
          >
            <div class="selected-users">
              <mat-chip
                *ngFor="let user of usersTemp"
                [removable]="true"
                (removed)="removeUser(user)"
              >
                {{ user }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            </div>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="createNewVisitorForm.controls.isReVisit.value"
            ><div class="checkbox-container">
              <mat-checkbox formControlName="requestVerification"
                >Request verification again</mat-checkbox
              >
            </div></mat-grid-tile
          >
          <mat-grid-tile *ngIf="false">
            <mat-form-field
              subscriptSizing="dynamic"
              appearance="outline"
              class="invite-form-fields"
            >
              <mat-label>Department</mat-label>
              <mat-select formControlName="department">
                <mat-option> Select </mat-option>
              </mat-select>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field
              subscriptSizing="dynamic"
              appearance="outline"
              class="invite-form-fields"
            >
              <mat-label>Pass Validity</mat-label>
              <input
                matInput
                readonly
                formControlName="ePassValidity"
                [matDatepicker]="Datepicker"
                [min]="minPassValidityDate"
                [max]="maxDate"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="Datepicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #Datepicker></mat-datepicker>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field
              subscriptSizing="dynamic"
              appearance="outline"
              class="invite-form-fields"
            >
              <mat-label>Purpose</mat-label>
              <mat-select formControlName="purpose">
                <mat-option value="Personal"> Personal </mat-option>
                <mat-option value="Official"> Official </mat-option>
                <mat-option value="Delivery"> Delivery </mat-option>
                <mat-option value="Meeting"> Meeting </mat-option>
                <mat-option value="Private"> Private </mat-option>
                <mat-option value="Classified"> Classified </mat-option>
              </mat-select>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile>
            <div class="checkbox-container" *ngIf="showField">
              <mat-checkbox formControlName="isVerified"
                >I have verified the visitor</mat-checkbox
              >
            </div>
          </mat-grid-tile>
          <mat-grid-tile>
            <div class="checkbox-container">
              <mat-checkbox formControlName="isTwoFactor"
                >Enable 2 factor Auth</mat-checkbox
              >
            </div>
          </mat-grid-tile>
          <mat-grid-tile>
            <div class="checkbox-container">
              <mat-checkbox formControlName="isLocationVerify"
                >Enable location based verification</mat-checkbox
              >
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            *ngIf="createNewVisitorForm.controls['isLocationVerify'].value"
          >
            <div class="div-button-wrapper">
              <div class="location-content">
                <mat-form-field subscriptSizing="dynamic" appearance="outline">
                  <mat-label>Visitor Location</mat-label
                  ><input
                    *ngIf="viewIncident != null"
                    matInput
                    [value]="viewIncident"
                  />
                  <input
                    *ngIf="viewIncident == null"
                    readonly
                    formControlName="visitorLocation"
                    matInput
                  />
                </mat-form-field>
                <button (click)="onClickOpenMap()" mat-icon-button>
                  <mat-icon>open_in_new</mat-icon>
                </button>
              </div>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            rowspan="4"
            [colspan]="screenInfo == ScreenType.Mobile ? '1' : '2'"
          >
            <div class="visitor-image-container">
              <mat-progress-bar
                mode="determinate"
                [value]="uploadProgressProfile"
              ></mat-progress-bar>
              <img [src]="urlProfile" alt="Profile photo" />
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            *ngIf="screenInfo == ScreenType.Mobile && !isDisabled"
            [colspan]="screenInfo == ScreenType.Mobile ? '1' : '2'"
          >
            <div class="button-container-upload">
              <label for="profilepic" class="upload-button-label"
                >Upload Profile</label
              >
              <input
                (click)="uploadProgressProfile = 0"
                style="display: none"
                id="profilepic"
                (change)="onUploadProfile($event)"
                type="file"
              />
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            rowspan="4"
            [colspan]="screenInfo == ScreenType.Mobile ? '1' : '2'"
            ><div class="visitor-image-container">
              <mat-progress-bar
                mode="determinate"
                [value]="uploadProgressId"
              ></mat-progress-bar>
              <img [src]="urlID" alt="Upload ID" /></div
          ></mat-grid-tile>
          <mat-grid-tile
            *ngIf="screenInfo != ScreenType.Mobile && !isDisabled"
            [colspan]="'2'"
          >
            <div class="button-container-upload">
              <label for="profilepic" class="upload-button-label"
                >Upload Profile</label
              >
              <input
                (click)="uploadProgressProfile = 0"
                style="display: none"
                id="profilepic"
                (change)="onUploadProfile($event)"
                type="file"
              />
            </div>
          </mat-grid-tile>

          <mat-grid-tile
            *ngIf="!isDisabled"
            [colspan]="screenInfo == ScreenType.Mobile ? '1' : '2'"
          >
            <div class="button-container-upload">
              <label for="idpic" class="upload-button-label">Upload ID</label>
              <input
                (click)="uploadProgressId = 0"
                style="display: none"
                id="idpic"
                (change)="onUploadID($event)"
                type="file"
              /></div
          ></mat-grid-tile>
        </mat-grid-list>
      </form> </mat-card-content
  ></mat-card>
</div>
<mat-divider></mat-divider>
<section *ngIf="showMsg" style="margin-top: 5px">
  <div
    [ngStyle]="
      isFaceMatched
        ? { 'background-color': 'green' }
        : { 'background-color': 'red' }
    "
    *ngIf="!isAPIRequest"
    class="display-message"
  >
    {{ faceMatchMsg | titlecase }}
  </div>
  <div *ngIf="isAPIRequest" class="display-message">
    <mat-spinner [diameter]="62"></mat-spinner>
  </div>
</section>

<section
  *ngIf="isRetry && !isManuallyVerify && !isAPIRequest"
  style="margin-bottom: 10px"
>
  <mat-divider></mat-divider>
  <div
    style="margin-top: 10px; background-color: whitesmoke; color: black"
    *ngIf="!isAPIRequest"
    class="display-message"
  >
    Details provided is not validated, Do you want to manually Verify?
  </div>
  <div *ngIf="isAPIRequest" class="display-message">
    <mat-spinner [diameter]="62"></mat-spinner>
  </div>
</section>

<div class="button-container" *ngIf="screenInfo == ScreenType.Mobile">
  <button (click)="onShowPreview()" mat-raised-button>
    {{ !isShowPreview ? "Show Preview" : "Close Preview" }}
  </button>
</div>
<br />
<mat-divider></mat-divider>
<div
  [ngClass]="{
    'visitor-invite-action':
      screenInfo == ScreenType.Desktop || screenInfo == ScreenType.Tablet,
    'visitor-invite-action-mobile': screenInfo == ScreenType.Mobile
  }"
>
  <mat-grid-list
    [cols]="
      screenInfo == ScreenType.Mobile
        ? '1'
        : (createNewVisitorForm.controls.isVerified.value && !isRetry) ||
          (createNewVisitorForm.controls.isVerified.value &&
            isRetry &&
            isAPIRequest)
        ? '3'
        : createNewVisitorForm.controls.isVerified.value && isRetry
        ? '4'
        : '2'
    "
    rowHeight="80px"
    gutterSize="20px"
  >
    <mat-grid-tile *ngIf="createNewVisitorForm.controls.isVerified.value">
      <button
        [disabled]="
          urlID?.length <= 10 ||
          urlProfile?.length <= 10 ||
          isManuallyVerify ||
          isFaceMatched ||
          isAPIRequest
        "
        (click)="onSelfVerifyVisitor()"
        mat-flat-button
      >
        {{ isFaceMatched ? "Verified" : "Verify" }}
      </button></mat-grid-tile
    >
    <mat-grid-tile *ngIf="isRetry && !isAPIRequest">
      <button
        [disabled]="urlID?.length <= 10 || urlProfile?.length <= 10"
        (click)="onManuallyVerifyVisitor()"
        mat-flat-button
      >
        Manually Verify
      </button></mat-grid-tile
    >
    <mat-grid-tile>
      <button
        [disabled]="
          createNewVisitorForm.invalid ||
          (createNewVisitorForm.controls.isVerified.value &&
            (urlID?.length <= 10 ||
              urlProfile?.length <= 10 ||
              !isFaceMatched)) ||
          isDisabled
        "
        (click)="onSendInvite()"
        mat-flat-button
      >
        Send Invite
      </button></mat-grid-tile
    >
    <mat-grid-tile>
      <button (click)="onCancel()" mat-flat-button>
        Cancel
      </button></mat-grid-tile
    >
  </mat-grid-list>
</div>
<br />
<div
  *ngIf="isShowPreview || screenInfo != ScreenType.Mobile"
  class="pass-preview-container"
>
  <mat-card class="pass-preview-card">
    <mat-card-header class="pass-preview-card-header"
      >E-Pass Preview</mat-card-header
    >
    <mat-card-content class="pass-preview-card-content">
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="preview-form-fields">
            <mat-label>First Name</mat-label>
            <input
              matInput
              readonly
              [value]="createNewVisitorForm.value.firstName"
            />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="preview-form-fields">
            <mat-label>Last Name</mat-label>
            <input
              matInput
              readonly
              [value]="createNewVisitorForm.value.lastName"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="preview-form-fields">
            <mat-label>Email</mat-label>
            <input
              matInput
              readonly
              [value]="createNewVisitorForm.value.email"
            />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="preview-form-fields">
            <mat-label>Contact Number</mat-label>
            <input
              matInput
              readonly
              [value]="createNewVisitorForm.value.phoneNumber"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="preview-form-fields">
            <mat-label>Meeting With</mat-label>
            <input
              matInput
              readonly
              [value]="createNewVisitorForm.value.hostUserId"
            />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="preview-form-fields">
            <mat-label>Address</mat-label>

            <textarea
              readonly
              cdkTextareaAutosize
              cdkAutosizeMaxRows="1"
              matInput
              placeholder=""
              [value]="createNewVisitorForm.value.visitorAddress"
            ></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="preview-form-fields">
            <mat-label>Purpose</mat-label>
            <input
              matInput
              readonly
              [value]="createNewVisitorForm.value.purpose"
            />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="preview-form-fields">
            <mat-label>Car Registration</mat-label>
            <input
              matInput
              readonly
              [value]="createNewVisitorForm.value.carRegistration"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="preview-image-container">
            <img [src]="urlID" alt="Uploaded ID" />
          </div>
        </div>
        <div class="col">
          <div class="preview-image-container">
            <img [src]="urlProfile" alt="Uploaded Profile Image" />
          </div>
        </div>
      </div>
      <div class="row" *ngIf="printerAllowed.includes(OrgId)">
        <div class="col">
          <div class="QR-container">
            <qrcode
              [qrdata]="'HI this is sachin raj here!'"
              [allowEmptyString]="true"
              [ariaLabel]="'QR Code image with the following content...'"
              [cssClass]="'center'"
              [colorDark]="'#E93578'"
              [elementType]="'canvas'"
              [errorCorrectionLevel]="'M'"
              [title]="'Visitor Invite Data'"
              [width]="300"
            >
            </qrcode>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
